import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import './mudar-senha.css';
import { UsersService } from '../../services/user';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer
} from '../../components';
import closedEye from '../cadastro/closed-eye.svg';
import openedEye from '../cadastro/opened-eye.svg';

export default class ViewMudarSenha extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "render_preloader": false,
      "render_success": false,
      "render_error": false,
      "error_message": "",
      "showCurrentPassword": false,
      "showNewPassword": false,
      "showRepeatPassword": false,
      "form": {
        "currentPassword": "",
        "newPassword": "",
        "repeatPassword": ""
      }
    }
  }

  componentDidMount() {
  }

  async alterarSenha() {
    var _this = this;
    _this.setState({
      "render_preloader": true,
      "render_error": false
    });

    var form = this.state.form;

    try {
      await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/reset/password`, {
        password: form.newPassword,
        current_password: form.currentPassword
      }, 'POST');

      _this.setState({
        "render_success": true,
        "render_preloader": false
      });
    } catch (e) {
      _this.setState({
        "render_error": true,
        "render_preloader": false,
        "error_message": e.message || "Erro ao alterar senha. Verifique os dados informados."
      });
    }
  }

  onChangeForm(field, value) {
    this.setState({
      form: {
        ...this.state.form,
        [field]: value
      }
    });
  }

  isFormValid() {
    const { form } = this.state;
    return form.currentPassword.trim() !== "" &&
      form.newPassword.length >= 6 &&
      form.repeatPassword.trim() !== "" &&
      form.newPassword === form.repeatPassword;
  }

  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const {
      render_preloader,
      render_success,
      render_error,
      form
    } = this.state;

    return <div className="rdp-react-template-view-mudar-senha">
      <div className="rdp-react-template-view-mudar-senha-header"
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          right: "0px",
          width: "100%",
          height: "100px",
          zIndex: 1
        }}>
        <HeaderShelf
          onSignOut={() => this.signOut()}
          renderSearch={false}
        />
      </div>

      <div className="rdp-react-template-view-mudar-senha-sidebar"
        style={{
          width: "50px",
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "0px"
        }}>
        <SidebarRoundedIcons />
      </div>

      <div className="rdp-react-template-view-mudar-senha-main" role="main">
        {render_preloader &&
          <div className="rdp-react-template-view-mudar-senha-preloader">
            <div className="rdp-react-template-view-mudar-senha-preloader-loader"></div>
          </div>
        }

        {render_error &&
          <div className="rdp-react-template-view-mudar-senha-error">
            <div className="rdp-react-template-view-mudar-senha-error-box">
              <span className="rdp-react-template-view-mudar-senha-error-box-icon"></span>
              <h1 className="rdp-react-template-view-mudar-senha-error-box-title">Erro ao alterar senha!</h1>
              <p className="rdp-react-template-view-mudar-senha-error-box-message">
                {this.state.error_message}
              </p>
              <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.setState({ "render_error": false })}>Voltar</button>
            </div>
          </div>
        }

        <div className="rdp-react-template-view-mudar-senha-container">
          <div className="rdp-react-template-view-mudar-senha-header-section">
            <h1 className="rdp-react-template-view-mudar-senha-title">Alterar senha</h1>
          </div>

          {render_success ? (
            <div className="rdp-react-template-view-mudar-senha-success">
              <p className="rdp-react-template-view-mudar-senha-message">
                Sua senha foi alterada com sucesso.
              </p>
              <button className="rdp-component-btn primary position-left" onClick={() => this.redirectTo("/")}>
                Voltar ao início
              </button>
            </div>
          ) : (
            <div className="rdp-react-template-view-mudar-senha-form">
              <div className="rdp-react-template-view-mudar-senha-input-container">
                <input
                  className="rdp-react-template-view-mudar-senha-input"
                  type={this.state.showCurrentPassword ? "text" : "password"}
                  placeholder="Senha atual *"
                  value={form.currentPassword}
                  onChange={(e) => this.onChangeForm('currentPassword', e.target.value)}
                />
                <button
                  type="button"
                  className="rdp-react-template-view-mudar-senha-toggle-password"
                  tabIndex="-1"
                  onClick={() => this.setState({ showCurrentPassword: !this.state.showCurrentPassword })}
                >
                  <img src={this.state.showCurrentPassword ? openedEye : closedEye} alt="Toggle Password Visibility" />
                </button>
              </div>

              <div className="rdp-react-template-view-mudar-senha-input-container">
                <input
                  className="rdp-react-template-view-mudar-senha-input"
                  type={this.state.showNewPassword ? "text" : "password"}
                  placeholder="Nova senha *"
                  value={form.newPassword}
                  onChange={(e) => this.onChangeForm('newPassword', e.target.value)}
                />
                <button
                  type="button"
                  className="rdp-react-template-view-mudar-senha-toggle-password"
                  tabIndex="-1"
                  onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
                >
                  <img src={this.state.showNewPassword ? openedEye : closedEye} alt="Toggle Password Visibility" />
                </button>
              </div>

              <div className="rdp-react-template-view-mudar-senha-input-container">
                <input
                  className="rdp-react-template-view-mudar-senha-input"
                  type={this.state.showRepeatPassword ? "text" : "password"}
                  placeholder="Confirme a nova senha *"
                  value={form.repeatPassword}
                  onChange={(e) => this.onChangeForm('repeatPassword', e.target.value)}
                />
                <button
                  type="button"
                  className="rdp-react-template-view-mudar-senha-toggle-password"
                  tabIndex="-1"
                  onClick={() => this.setState({ showRepeatPassword: !this.state.showRepeatPassword })}
                >
                  <img src={this.state.showRepeatPassword ? openedEye : closedEye} alt="Toggle Password Visibility" />
                </button>
              </div>
              {form.newPassword && form.repeatPassword && form.newPassword !== form.repeatPassword && (
                <span className="rdp-react-template-view-mudar-senha-error-text">A senha não corresponde</span>
              )}

              <div className="rdp-component-btn-group-flex">
                <button className="rdp-component-btn secondary position-left icon-left" onClick={() => window.history.back()}>Voltar</button>
                <button
                  className={`rdp-component-btn primary position-right icon-right ${!this.isFormValid() ? "inactive" : ""}`}
                  onClick={() => this.alterarSenha()}
                  disabled={!this.isFormValid()}
                >
                  {render_preloader ? "Aguarde..." : "Alterar senha"}
                </button>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    </div>;
  }
}